var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoCorreoContacto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 75,
    viewBox: "0 0 94 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 75C6.815 75 4.60287 74.0828 2.7636 72.2484C0.924334 70.4141 0.00313333 68.2062 0 65.625V9.375C0 6.79687 0.9212 4.59062 2.7636 2.75625C4.606 0.921874 6.81813 0.003125 9.4 0H84.6C87.185 0 89.3987 0.918749 91.2411 2.75625C93.0835 4.59375 94.0031 6.8 94 9.375V65.625C94 68.2031 93.0804 70.4109 91.2411 72.2484C89.4018 74.0859 87.1881 75.0031 84.6 75H9.4ZM47 42.1875L84.6 18.75V9.375L47 32.8125L9.4 9.375V18.75L47 42.1875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCorreoContacto);
export default __webpack_public_path__ + "static/media/icono_correo_contacto.1fc7e335bc3d4d380d72e8c4088a9258.svg";
export { ForwardRef as ReactComponent };